import { render, staticRenderFns } from "./ModuleCardGrid.vue?vue&type=template&id=3c0a623a&scoped=true&"
var script = {}
import style0 from "./ModuleCardGrid.vue?vue&type=style&index=0&id=3c0a623a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a623a",
  null
  
)

export default component.exports